import { getTrendingMLDrivenItems } from "../../fetch/graphql/requests/mlDrivenItems/library";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { DEFAULT_SWIMLANE_LAYOUT } from "../../components/LayoutFactory/constants";
import { video_trending_update, video_trending_error } from "./actions";

export const fetchTrendingVideos = (
    limit,
    path,
    layout = DEFAULT_SWIMLANE_LAYOUT
) => {
    return async (dispatch) => {
        try {
            const result = await getTrendingMLDrivenItems(limit);
            const cardContentItems = result?.data?.mlDrivenItems?.items;
            const transformedContentItems = cardContentItems?.length
                ? transformAllContentItems(cardContentItems)
                : [];

            const trendingVideos = transformAllContentItems?.length
                ? transformForLayouts(transformedContentItems, layout, path)
                : [];

            return dispatch(video_trending_update(trendingVideos));
        } catch (error) {
            return dispatch(video_trending_error(error));
        }
    };
};
